import '../css/main.css'
import './vendor-css.js';

import "./components/accordion.js";
import "./components/contact-form.js";
import "./components/cookie-settings.js";
import "./components/counter.js";
import "./components/footer.js";
import "./components/header.js";
import "./components/hero.js";
import "./components/imagesize.js";
import "./components/load-more.js";
import "./components/modal.js";
import "./components/navigation.js";
import "./components/teaser-animated.js";

const lazyComponents = [
    [".teaser-locations, .teaser-news", () => import("./components/slider.js")],
    ["[data-joboffers], .teaser-joboffers", () => import("./components/joboffers.js")],
    [".video-custom, .video-youtube", () => import("./components/video.js")],
    [".iframe-wrapper iframe", () => import("./components/iframe.js")],
];

lazyComponents.forEach(([selector, load]) => {
    if (document.querySelector(selector)) load();
});
